import React, { memo, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import MemberIntroductions from './Panels/MemberIntroductions'
import MemberEvents from './Panels/MemberEvents'
import MemberPosts from './Panels/MemberPosts'
import LatestHomestays from './Panels/LatestHomestays'
import FeaturedHomestayHosts from './Panels/FeaturedHomestayHosts'
import LatestActivity from './Panels/LatestActivity'
import MyFreebirdDashboardLeft from './MyFreebirdDashboardLeft'
import MyFreebirdDashboardRight from './MyFreebirdDashboardRight'
import styled from 'styled-components'

const Dashboard = styled.div``

const FlexRowDashboard = styled.div`
  display: flex;
  flex-direction: row;
  gap: 28px;
  align-items: stretch;
  margin-bottom: 20px;

  @media screen and (max-width: 799px) {
    flex-direction: column;
  }
`

const MyFreebirdDashboard = memo(
  ({
    pageText,
    user,
    accountStatus,
    subscriptionType,
    messageTrigger,
    forbiddenLinkClicked,
  }) => {
    const [eventsTitle, setEventsTitle] = useState('')

    if (!user) {
      return (
        <div className="card-body text-center">
          <div
            className="spinner-border homestays-spinner"
            style={{ margin: '100px auto 100px', opacity: '0.3' }}
            role="status"
          ></div>
        </div>
      )
    }
    return (
      <Dashboard>
        <FlexRowDashboard>
          {' '}
          <MyFreebirdDashboardLeft
            u={user}
            color={'#F6E8F3'}
            title={eventsTitle}
            addPopup={true}
            messageTrigger={messageTrigger}
          >
            <MemberEvents
              pageText={pageText}
              accountStatus={accountStatus}
              subscriptionType={subscriptionType}
              titleTrigger={setEventsTitle}
              messageTrigger={messageTrigger}
              forbiddenLinkClicked={forbiddenLinkClicked}
            />
          </MyFreebirdDashboardLeft>
          <MyFreebirdDashboardRight
            u={user}
            color={'#E8F6EB'}
            title={pageText[42]}
          >
            <MemberIntroductions
              accountStatus={accountStatus}
              subscriptionType={subscriptionType}
            />
          </MyFreebirdDashboardRight>
        </FlexRowDashboard>
        <FlexRowDashboard>
          {' '}
          <MyFreebirdDashboardLeft
            u={user}
            color={'#E7F7F9'}
            title={pageText[41]}
            addPopup={false}
          >
            <LatestHomestays
              accountStatus={accountStatus}
              subscriptionType={subscriptionType}
            />
          </MyFreebirdDashboardLeft>
          <MyFreebirdDashboardRight
            u={user}
            color={'#FFf6E1'}
            title={pageText[40]}
          >
            {' '}
            <MemberPosts
              accountStatus={accountStatus}
              subscriptionType={subscriptionType}
            />
          </MyFreebirdDashboardRight>
        </FlexRowDashboard>
        <FlexRowDashboard>
          {' '}
          <MyFreebirdDashboardLeft
            u={user}
            color={'#E7F7F9'}
            title={pageText[37]}
            addPopup={false}
          >
            <LatestActivity user={user} />
          </MyFreebirdDashboardLeft>
          <MyFreebirdDashboardRight
            u={user}
            color={'#FFf6E1'}
            title={pageText[38]}
          >
            <FeaturedHomestayHosts
              user={user}
              accountStatus={accountStatus}
              subscriptionType={subscriptionType}
              messageTrigger={messageTrigger}
            />
          </MyFreebirdDashboardRight>
        </FlexRowDashboard>
      </Dashboard>
    )
  }
)

export default withRouter(withAuth(MyFreebirdDashboard))
